/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/selfpromotionManage',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '自营-促销活动',
      icon: 'component',
    },
    children: [
      {
        path: '/selfpromotionManage/singleitem',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/singleitem/singleitemList.vue'),
        alwaysShow: false,
        name: 'singleitem',
        meta: {
          title: '单品促销',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/singleitemAdd',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/singleitem/singleitemAdd.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'singleitemAdd',
        meta: {
          title: '新增单品促销',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/compositeSale',
        component: {render(c) {return c('router-view')}},
        alwaysShow: false,
        hidden: false,
        name: 'compositeSaleList',
        meta: {
          title: '搭销组合',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children:[
          {
            path: '/selfpromotionManage/compositeSale/compositeSaleList',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/compositeSale/compositeSaleList.vue'),
            alwaysShow: true,
            name: 'compositeSaleList',
            meta: {
              title: '搭销活动列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfpromotionManage/compositeSale/compositeSaleAdd',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/compositeSale/compositeSaleAdd.vue'),
            alwaysShow: false,
            hidden: true,
            name: 'compositeSaleAdd',
            meta: {
              title: '新增搭销活动',
              icon: 'component',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfpromotionManage/compositeSale/compositeComList',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/compositeSale/compositeComList.vue'),
            alwaysShow: false,
            hidden: false,
            name: 'compositeComList',
            meta: {
              title: '搭销组合列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          }
        ]
      },
      {
        path: '/selfpromotionManage/jointpromotion',
        component: {render(c) {return c('router-view')}},
        alwaysShow: false,
        hidden: false,
        name: 'jointpromotionList',
        meta: {
          title: '满赠活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children:[
          {
            path: '/selfpromotionManage/fullNpriceGive',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/fullNpriceGive/fullNpriceGiveList.vue'),
            alwaysShow: true,
            name: 'fullNpriceGiveList',
            meta: {
              title: '满N元送',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfpromotionManage/fullNpriceGiveAdd',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/fullNpriceGive/fullNpriceGiveAdd.vue'),
            alwaysShow: true,
            hidden: true,
            name: 'fullNpriceGiveAdd',
            meta: {
              title: '新建满N元送',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfpromotionManage/fullNpieceGive',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/fullNpieceGive/fullNpieceGiveList.vue'),
            alwaysShow: true,
            hidden: false,
            name: 'fullNpieceGiveList',
            meta: {
              title: '满N件送',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfpromotionManage/fullNpieceGiveAdd',
            component: () => import('@/myviews/shoppMall/selfpromotionManage/fullNpieceGive/fullNpieceGiveAdd.vue'),
            alwaysShow: true,
            hidden: true,
            name: 'fullNpieceGiveAdd',
            meta: {
              title: '新建满N件送',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
        ]
      },
      {
        path: '/selfpromotionManage/flashsale',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/flashsale/flashsaleList.vue'),
        alwaysShow: false,
        name: 'flashsaleList',
        meta: {
          title: '秒杀活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/flashsaleAdd',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/flashsale/flashsaleAdd.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'flashsaleAdd',
        meta: {
          title: '新增秒杀活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/flashsaleRecordsList',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/flashsale/flashsaleRecordsList.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'flashsaleRecordsList',
        meta: {
          title: '秒杀记录',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/luckdraw',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/luckdraw/luckdrawList.vue'),
        alwaysShow: false,
        name: 'luckdrawList',
        meta: {
          title: '抽奖活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/lotteryRecords',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/luckdraw/lotteryRecordsList.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'lotteryRecordsList',
        meta: {
          title: '抽奖记录',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/luckdrawAdd',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/luckdraw/luckdrawAdd.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'luckdrawAdd',
        meta: {
          title: '新建抽奖活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/superPurchase',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/superPurchase/superPurchaseList.vue'),
        alwaysShow: false,
        name: 'superPurchaseList',
        meta: {
          title: '超值加购',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/superPurchaseAdd',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/superPurchase/superPurchaseAdd.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'superPurchaseAdd',
        meta: {
          title: '新建超值加购',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfpromotionManage/superPurchaseRecordsList',
        component: () => import('@/myviews/shoppMall/selfpromotionManage/superPurchase/superPurchaseRecordsList.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'superPurchaseRecordsList',
        meta: {
          title: '超值加购记录',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/selfpromotionManage.js